import {isCartStep, formatNumber, formatDate, getCdnImageUrl} from "../functions";
import {Layout} from "./layout";
import {isLogged, getCustomerGuid} from "../customer";
import * as api from '../api';

var authCardPrice = 0;
var render = function () {

	if (isLogged()) {
		var deliveryMethods = [];
		var items = [];
		var deliveryMethodsRequests = api.getData('get-delivery-methods', { guid: getCustomerGuid() }, {async: false}).responseJSON;
		var cartRequests = api.getData('get-cart', { guid: getCustomerGuid() }, {async: false}).responseJSON;

		deliveryMethodsRequests.forEach(function (method, index) {
			deliveryMethods.push(`<tr class="radio-wrapper ${index === 0 ? 'active' : ''}" data-id="shipping-${method.id}">
											<td class="shipping-single-name large-8">
	                                 <label for="shippingId-${method.id}">
	                                 <input 
	                                    type="radio" 
	                                    required 
	                                    name="subShippingId" 
	                                    id="shippingId-${method.id}" 
	                                    value="${method.guid}" 
	                                    data-id="${method.id}"
	                                    data-name="${method.name}" 
	                                    data-price="${method.price}" ${index === 0 ? 'checked' : ''}>
	                                 <strong class="shipping-billing-name">${method.name}</strong>
	                                 </label>
	                              </td>
	                              <td class="shipping-single-logo mobile-hide hide-for-small-only large-2">
	                                 <img src="${method.logo}" alt="${method.name}">
	                              </td>
	                              <td class="shipping-single-rest tar large-2">
	                                 <span class="payment-shipping-price">${method.price === 0 ? 'ZDARMA' : formatNumber(method.price) + ' Kč'}</span>
	                              </td>
	                           </tr>`);
		});
		cartRequests.data.forEach(function (child) {
				child.items.forEach(function (item) {
					items.push(`<div class="recapitulation-single">
	                        <div class="reca-p-name large-8 left">
	                           <a href="#" title="${item.name}">
	                           <span data-testid="recapItemAmount">${item.quantity}x</span>
	                           <span data-testid="recapItemName">${item.name}</span>
	                           </a>
	                        </div>
	                        <div class="reca-p-price large-4 left tar" data-testid="recapItemPrice">
	                           <strong class="nowrap">
	                           ${formatNumber(item.priceWithDiscount*item.quantity)} Kč
	                           </strong>
	                        </div>
	                        <div class="clear">&nbsp;</div>
	                     </div>`);
				})
		})

		var period = "Každých " + cartRequests.repeat + " dní";
		if(cartRequests.repeat === 14) {
			period = '2x každý měsíc';
		} else if (cartRequests.repeat === 30) {
			period = '1x každý měsíc';
		} else if (cartRequests.repeat === 60) {
			period = '1x každé 2 měsíce';
		}

		var authCardItem = '';

		if(!cartRequests.hasActiveCard) {
			authCardItem = `<div class="recapitulation-single recapitulation-shipping-billing last" data-testid="recapCartItem"><span class="recapitulation-shipping-billing-label">Platba:</span> <strong class="recapitulation-shipping-billing-info" data-testid="recapDeliveryMethod"><span data-testid="recapItemPrice">
                           <span>1 kč</span>
                           </span> Autorizace plat. karty</strong>
                        </div>`;
			authCardPrice = 1;
		}

		return Layout(`<article>
   <div>
      <div id="order-step-1" class="delivery order-page row fixed-sidebar-wrapper" style="min-height: 567px;">
        
         <form name="orderForm" action="#" method="post" id="sub-order-form">
            <div id="order-left" class="large-8 medium-8 small-12 columns fixed-sidebar-sibling">
               <fieldset class="f-border checkout-single-box">
                  <legend>Zvolte způsob dopravy</legend>
                  <div class="f-border-in" data-testid="shippingMethods">
                     <table id="sub-shipping-methods" class="shipping-billing-table">
                        <tbody>
                           ${deliveryMethods.join('')}
                        </tbody>
                     </table>
                  </div>
               </fieldset>
              
            </div>
            <div id="order-right" class="large-4 medium-4 small-4 columns fixed-sidebar" data-width="33.333333">
               <fieldset class="f-border checkout-single-box" itemscope="" itemtype="https://schema.org/Organization">
                  <legend>Potřebujete pomoc?</legend>
                  <div class="f-border-in row collapse" id="checkout-contact">
                     <div class="merchant-photo large-3 columns tac">
                        <img src="${getCdnImageUrl(`/user/merchant/logo_healthacademy-rgb-horizontal.jpg`)}" alt="Kontakt">
                     </div>
                     <div id="checkout-contact-right" class="large-8 columns">
                        <div class="contacts-email ccr-single">
                           <span class="checkout-mail icon-mail-before text-word-breaking" itemprop="email">
                              <a href="mailto:objednavky@healthfactory.cz">
                                 objednavky<!---->@<!---->healthfactory.cz
                              </a>
                           </span>
                        </div>
                        <div class="contacts-phone ccr-single">
                           <span class="checkout-tel icon-phone-before text-word-breaking" itemprop="telephone">+420 725 788 664</span>
                        </div>
                     </div>
                  </div>
               </fieldset>
               <fieldset class="f-border checkout-single-box" id="summary-box">
                  <legend>Rekapitulace předplatného</legend>
                  <div class="f-border-in" id="checkout-recapitulation">
                     
                     <div class="recapitulation-single">
	                        <div class="reca-p-name large-8 left">
	                           <span data-testid="recapItemName">KDY BUDEME ZASILKU ODESÍLAT:</span>
	                        </div>
	                        <div class="reca-p-price large-4 left tar" data-testid="recapItemPrice">
	                           <strong class="nowrap">
	                           ${formatDate(cartRequests.firstDate)}
	                           </strong>
	                        </div>
	                        <div class="clear">&nbsp;</div>
	                     </div>
	                     
	                     <div class="recapitulation-single">
	                        <div class="reca-p-name large-8 left">
	                           <span data-testid="recapItemName">JAK ČASTO VÁM BUDEME ODESÍLAT:</span>
	                        </div>
	                        <div class="reca-p-price large-4 left tar" data-testid="recapItemPrice">
	                           <strong class="nowrap">
	                           ${period}
	                           </strong>
	                        </div>
	                        <div class="clear">&nbsp;</div>
	                     </div>
	                     <div class="recapitulation-single">
	                        <div class="reca-p-name large-8 left">
	                           <span data-testid="recapItemName">CHYTRÉ PŘEDPLATNÉ:</span>
	                        </div>
	                        <div class="reca-p-price large-4 left tar" data-testid="recapItemPrice">
	                           <strong class="nowrap">
	                           ${cartRequests.smartSubscription ? 'ANO' : 'NE'}
	                           </strong>
	                        </div>
	                        <div class="clear">&nbsp;</div>
	                     </div>
	                     
                     ${items.join('')}
                     
                     <div id="summary-merchandise">
                        <strong class="strong-bigger">Celkem za produkt</strong>
                        <span class="fr tar">
                        <strong class="strong-bigger" data-testid="recapItemTotalPrice">
                        ${formatNumber(cartRequests.totalPrice)} Kč
                        </strong>
                        </span>
                     </div>
                     <div id="shipping-billing-summary" class="order-recapitulation">
                        <div class="recapitulation-single recapitulation-shipping-billing" data-testid="recapCartItem">
                           <span class="recapitulation-shipping-billing-label">Doprava:</span>
                           <strong class="recapitulation-shipping-billing-info">
                              <span data-testid="recapItemPrice">${deliveryMethodsRequests[0].price === 0 ? 'Zdarma' : formatNumber(deliveryMethodsRequests[0].price) + ' Kč'}</span> ${deliveryMethodsRequests[0].name}
                           </strong>
                        </div>
                        ${authCardItem}
                     </div>
                     <div id="summary-cart" class="order-summary-item price" data-totalPrice="${cartRequests.totalPrice}">
                        <div class="reca-final-left">
                           <strong class="reca-big-text">Cena vč. DPH:</strong><br>
                           Cena bez DPH:
                        </div>
                        <div class="reca-final-right">
                           <strong class="reca-big-text red price-wrapper">
                           <span data-testid="recapFullPrice">${formatNumber(cartRequests.totalPrice+authCardPrice+deliveryMethodsRequests[0].price)} Kč</span>
                           </strong>
                           <br>
                           <div class="final-novat-price">
                              <span>${formatNumber(cartRequests.totalPriceWithoutVat+(authCardPrice/1.21)+deliveryMethodsRequests[0].price)} Kč</span>
                           </div>
                        </div>
                        <div class="clear">&nbsp;</div>
                     </div>
                  </div>
               </fieldset>
               <div class="buttons-order buttons-order-step1 tar">
                  <span class="continue-shopping">
                  <a href="/predplatne/" title="Zpět" class="back-href fl" data-testid="prevStep" rel="nofollow">Zpět</a>
                  </span>
                  <span class="complete-shopping">
                  <input type="submit" value="Pokračovat" class="b-next normal button success js-orderFormSubmit" data-testid="nextStep">
                  </span>
               </div>
            </div>
         </form>
      </div>
   </div>
</article>`, 1);
	} else {
		return Layout('<p>Musíte být přihlášen</p>', 1)
	}
}

if ($('body').hasClass('in-predplatne') && isCartStep(2)) {
	$('#main-in').html(render())
}

$(document).on('change', '[name="subShippingId"]', function () {
	var name = $(this).data('name');
	var price = $(this).data('price');
	var totalPrice = $('.order-summary-item').data('totalprice')


	$('#sub-shipping-methods .active').removeClass('active');
	$(this).closest('.radio-wrapper').addClass('active');

	$('.recapitulation-shipping-billing-info:first').html(`<span data-testid="recapItemPrice">
                           ${price === 0 ? 'Zdarma' : formatNumber(price) + " Kč"}
                           </span> ${name}`)
	$('[data-testid="recapFullPrice"]').text(formatNumber(totalPrice + price + authCardPrice) + ' Kč');
});

$(document).on('submit', '#sub-order-form', function (e) {
	e.preventDefault();
	showSpinner();
	api.patchData('update-cart', {
		deliveryMethodGuid: $(this).find('[name="subShippingId"]:checked').val()
	}, {
		guid: getCustomerGuid(),
	}).done(function () {
		window.location.href = '?step=3';
	})

})